import { ReportStatus } from "@/graphql/generated";

export const REPORT_STATUS_TABS: Array<{
  labelKey: string;
  value: ReportStatus | null;
}> = [
  { labelKey: "reports.filter.statusAll", value: null },
  { labelKey: "reports.filter.statusGenerating", value: ReportStatus.Generating },
  { labelKey: "reports.filter.statusPending", value: ReportStatus.Pending },
  { labelKey: "reports.filter.statusComplete", value: ReportStatus.Complete },
  { labelKey: "reports.filter.statusFailed", value: ReportStatus.Failed },
];

export const VALID_REPORT_STATUS_VALUES: ReadonlySet<string> = new Set([
  ReportStatus.Generating,
  ReportStatus.Pending,
  ReportStatus.Complete,
  ReportStatus.Failed,
]);

// In-flight + needs-attention first, complete last. Drives the "Status"
// sortable column so ASC surfaces actionable rows (GENERATING, PENDING,
// FAILED) at the top.
export const REPORT_STATUS_ORDER: Record<ReportStatus, number> = {
  [ReportStatus.Generating]: 0,
  [ReportStatus.Pending]: 1,
  [ReportStatus.Failed]: 2,
  [ReportStatus.Complete]: 3,
};

export const REPORTS_PAGE_SIZE = 12;
